import styled from "styled-components";

export const ResultsDiv = styled.div`
display: flex;
justify-content: center;
`

export const MainContainerResults = styled.div`

`

export const AlignDiv = styled.div`
width: 530px;


display: flex;
justify-content: space-between;

`